// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","653":"component---src-pages-index-sv-js"}[chunkId] + "-" + {"125":"b7f3916a30e91178da21","653":"232d6827bf467cf24fd1"}[chunkId] + ".js";
};